import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const getTrainingTypes = () => {
  return apiRequestType(apiTypes.GET, apiConstants.MANAGE.GET_TRAINING_TYPES);
};

export default getTrainingTypes;
